var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13ZM12.9913 13.2087C14.9083 13.2087 16.4666 11.7043 16.4666 9.85486C16.4666 8.00481 14.9083 6.5 12.9913 6.5C11.0747 6.5 9.51603 8.00481 9.51603 9.85486C9.51603 11.7043 11.0747 13.2087 12.9913 13.2087ZM16.4243 15.14C15.7959 15.5209 15.1137 15.7911 14.4063 15.9467L16.349 17.8222C16.747 18.2056 16.747 18.8282 16.349 19.212C15.9515 19.5958 15.3071 19.5958 14.9099 19.212L12.9998 17.369L11.0913 19.212C10.8923 19.4037 10.6315 19.4996 10.3708 19.4996C10.1104 19.4996 9.8501 19.4037 9.6511 19.212C9.25352 18.8282 9.25352 18.206 9.65068 17.8222L11.5937 15.9467C10.8863 15.7911 10.204 15.5205 9.57562 15.14C9.10006 14.8505 8.95721 14.2441 9.25685 13.7847C9.55566 13.3246 10.184 13.1861 10.6604 13.4756C12.0832 14.3395 13.9159 14.3397 15.3395 13.4756C15.8159 13.1861 16.4441 13.3246 16.7435 13.7847C17.0431 14.2437 16.8999 14.8505 16.4243 15.14Z",
    fill: "#A0A6C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9917 8.46606C13.7852 8.46606 14.4306 9.0889 14.4306 9.85485C14.4306 10.6202 13.7852 11.2434 12.9917 11.2434C12.1988 11.2434 11.5527 10.6202 11.5527 9.85485C11.5527 9.0889 12.1988 8.46606 12.9917 8.46606Z",
    fill: "#A0A6C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/ok.a343406f9ec4cf1d6d5f906cde7936eb.svg";
export { ForwardRef as ReactComponent };